import { http, HttpResponse } from 'msw';

import { documents, document } from './fixture/document';

export const documentHandlers = [
  http.get('**/documents', () => HttpResponse.json({ documents })),
  http.get('**/documents/:documentKey', () => HttpResponse.json({ document })),
];
